import React, {type JSX} from 'react';
import {Card} from 'semantic-ui-react';

import {DD_PRIVACY_HIDDEN} from '../../util/datadog/privacy';

const CARD_STYLE: React.CSSProperties = {
  width: '100%',
};

interface HtmlViewerProps {
  headerElements?: JSX.Element[];
  notFoundElements?: React.ReactNode;
  htmlNotFound?: boolean;
  height?: number;
  src?: string;
  trackSuccess?: () => void;
  trackError?: () => void;
}

// a single image card
const HtmlViewer = (props: HtmlViewerProps) => {
  const {
    headerElements,
    notFoundElements,
    height,
    htmlNotFound,
    src,
    trackSuccess,
    trackError,
  } = props;

  return (
    <div
      data-test="html-viewer"
      style={{padding: '10px', height: '100%', width: '100%'}}>
      <Card className="html-card" style={CARD_STYLE}>
        {headerElements}
        {/* eslint-disable-next-line no-extra-boolean-cast */}
        {!!htmlNotFound ? (
          notFoundElements
        ) : (
          <iframe
            data-dd-privacy={DD_PRIVACY_HIDDEN}
            title="Html card"
            sandbox="allow-scripts"
            style={{border: 'none', height: (height ? height : 300) - 50}}
            src={src}
            onLoad={trackSuccess}
            onError={trackError}
          />
        )}
      </Card>
    </div>
  );
};

export default HtmlViewer;
